/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import Navigation from './Navigation';
import Policy from './Policy';

// Composant d'affichage des messages d'erreur
const ValidationMessage = ({ isValid, validationType }) => {
  if (isValid) return null;

  const messages = {
    phone: 'Veuillez entrer un numéro valide',
    email: 'Veuillez entrer un email valide',
    codepostal: 'Veuillez entrer un code postal valide',
  };

  return <div className="validate-error mt-10">{messages[validationType]}</div>;
};

// Composant pour un champ de formulaire
const FormField = ({ item, value, onChange, onKeyPress, onForm, validationState }) => {
  const isNumberType = item.type === 'number';

  const commonProps = {
    name: item.name,
    placeholder: item.placeholder,
    onChange,
    onKeyPress,
    value: value || '',
  };

  return (
    <div className="input-container flex-input mb-1" key={item.name}>
      <label className="mt-10" style={{ width: '90px' }}>
        {item.label}
      </label>
      <div className="mt-5">
        {isNumberType ? (
          <input
            type="number"
            min={item.min}
            step={item.step}
            autoFocus
            {...commonProps}
          />
        ) : (
          <input
            type={item.type || 'text'}
            maxLength={item.maxLength}
            minLength={item.minLength}
            {...commonProps}
          />
        )}
        {onForm && item.validation && (
          <ValidationMessage
            isValid={validationState[`${item.validation}Valid`]}
            validationType={item.validation}
          />
        )}
      </div>
    </div>
  );
};

const QuestionsText = ({
  dataItems,
  name,
  userContact,
  handleData,
  nextStep,
  lastStep,
  step,
  onCleanData,
  handleAutofill,
  emailValid,
  phoneValid,
  codepostalValid,
  onForm,
  data,
  dataLayer,
  dataLayerName,
  dataLayerEvent,
}) => {
  const [policyChecked, setPolicyChecked] = useState(false);
  
  // Récupérer les configurations depuis les dataItems
  const questionConfig = dataItems[name];
  const isOptional = !!questionConfig?.optional;
  const hasPolicy = !!questionConfig?.policy;

  useEffect(() => {
    // Focus sur le premier input au montage
    const firstInput = document.querySelector('input:not(input[type="radio"])');
    if (firstInput) {
      firstInput.focus();
    }

    // Gérer l'autofill pour Q29 et le GTM
    if (name === 'Q29') {
      
      // Appel de handleAutofill si c'est une fonction
      if (typeof handleAutofill === 'function') {
        handleAutofill();
      }
    }
  }, []);

  const handlePolicyChange = (e) => {
    setPolicyChecked(e.target.checked);
  };

  const enterNext = (e) => {
    if (e.key === 'Enter' && canGoToNextStep()) {
      nextStep();
    }
  };

  const allFieldsHaveValue = () => {
    const filledItems = questionConfig.items.filter(
      (item) => userContact[item.name] !== '',
    );

    if (filledItems.length < 4) {
      return false;
    }

    return emailValid && phoneValid && policyChecked;
  };

  const canGoToNextStep = () => {
    return (
      (data && (!hasPolicy || policyChecked)) ||
      (isOptional && allFieldsHaveValue())
    );
  };

  const validationState = {
    emailValid,
    phoneValid,
    codepostalValid,
  };

  return (
    <div className="fadeIn flex flex-col justify-between">
      <div className="w-100 d-flex jcc">
        <div
          style={{ minWidth: '360px' }}
          className="d-flex column items-center mb-14"
        >
          <div>
            <div className="mb-30">
              {questionConfig.items.map((item) => (
                <FormField
                  key={item.name}
                  item={item}
                  value={userContact[item.name]}
                  onChange={handleData}
                  onKeyPress={enterNext}
                  onForm={onForm}
                  validationState={validationState}
                />
              ))}
              {hasPolicy && (
                <div className="mt-20">
                  <Policy onChange={handlePolicyChange} />
                </div>
              )}
            </div>
          </div>

          <div className="w-full">
            <button
              onClick={() => {
                onCleanData();
                nextStep();
              }}
              className="bg-transparent border-none underline font-bold text-[#3A3A3AE0] cursor-pointer"
            >
              Je ne souhaite pas donner mes coordonnées
            </button>
          </div>
        </div>
      </div>

      <Navigation
        data={canGoToNextStep()}
        step={step}
        nextStep={nextStep}
        lastStep={lastStep}
      />
    </div>
  );
};

export default QuestionsText;